import createQueryParamsForGetReq from "helper/createQueryParamsForGetReq";
import { useQuery } from "react-query";

import apiEndPoints from "services/apiEndPoints";
import makeApiRequest from "services/makeApiRequest";

export default function useGetUnreadMessages() {
  return useQuery(
    "unreadmessages",
    async () => {
      const response = await makeApiRequest.get(
        createQueryParamsForGetReq(apiEndPoints.GET_UNREADMESSAGESCOUNT, {}),
      );

      return response.data;
    },
    // { refetchInterval: 2000 }
  );
}
